import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetOperatingActivitiesNetCashCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [operatingActivitiesNetCashFiled] = observedFields.operatingActivitiesNetCash.setCalculatedValueFieldNames;

  const getOperatingActivitiesNetCashCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const operatingActivitiesNetCash = summarizeSubtractPeriodValues(content, PERIODS_OPERATION_TYPES.ADD);

        setValue(operatingActivitiesNetCashFiled, operatingActivitiesNetCash);
      }, 500),
     
    [],
  );

  return getOperatingActivitiesNetCashCalculationHandler;
};
